import { render, staticRenderFns } from "./TheEditPage.vue?vue&type=template&id=286f1270"
import script from "./TheEditPage.vue?vue&type=script&lang=js"
export * from "./TheEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports